import { createContext, ReactNode, useMemo } from 'react';

import { defaultClientConfig, type ClientConfig } from 'config/clientConfigObj';

export type Props = {
  children: ReactNode;
  value?: ClientConfig;
};

export const ClientConfigContext = createContext<ClientConfig>(defaultClientConfig);

export function ClientConfigProvider({ children, value }: Props) {
  const memoizedValue = useMemo(() => value || defaultClientConfig, [value]);

  return <ClientConfigContext.Provider value={memoizedValue}>{children}</ClientConfigContext.Provider>;
}
